import React, { Component } from 'react';
import spanish from '../../../common/language/spanis';
import english from '../../../common/language/english';
import image from '../../../assets/aboutUs/image.jpg';
import layout from '../../../common/layout';
import styles from './about.module.css';
let lang = spanish;

class AboutUs extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    componentWillReceiveProps(next) {
        // console.log(next);
        if (next.language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }

    render() {
        return (
            <div className="marg" style={{ textAlign:'center' }} id="about">
                <p className={`mainTitle ${styles.title}`}>{lang.aboutUs.title}</p>
                <p style={{color:layout.gold}} className={styles.description}>{lang.aboutUs.places}</p>
                <img src={image} className={styles.image}/>
            </div>
        );
    }
}

export default AboutUs;